import {
  ORG_EXPORT_FILE_EXTENSION,
  ORG_EXPORT_FILE_FALLBACK_ORG_NAME,
  ORG_EXPORT_FILE_LABEL,
  ORG_EXPORT_FILE_SEPARATOR,
} from '../../modules/catch-core/data/constants/app.constants';
import { formatFileNameTimestamp, sanitizeFileNamePart } from './catchhub-log-export.helper';

/**
 * Builds the organisation export file name: `Organisation Data of_{OrgName}_dd_mm_yyyy_hh_mm_ss.json`.
 *
 * The timestamp is the downloader's local time. A missing or unusable org name falls back to a
 * generic one rather than producing `Organisation Data of__...`.
 */
export function buildOrgExportFileName(orgName: string | null | undefined, now: Date = new Date()): string {
  const safeName = sanitizeFileNamePart(orgName) || ORG_EXPORT_FILE_FALLBACK_ORG_NAME;
  const safeNow = now && !isNaN(now.getTime()) ? now : new Date();
  const timestamp = formatFileNameTimestamp(safeNow, ORG_EXPORT_FILE_SEPARATOR);

  return [ORG_EXPORT_FILE_LABEL, safeName, timestamp].join(ORG_EXPORT_FILE_SEPARATOR) + ORG_EXPORT_FILE_EXTENSION;
}
